﻿// ─── Generic ──────────────────────────────────────────────────────────────────
export const API_BASE_URL = import.meta.env.VITE_DAIKING_API ?? "";
export const APP_TIMEZONE = "Europe/Istanbul";
export const BASE_URL = "/";

export const AZURE_ACTIVE_DOMAIN = {
  appId: import.meta.env.VITE_AZURE_APP_ID ?? "",
  redirectUri:
    import.meta.env.VITE_AZURE_REDIRECT_URI ?? window.location.origin,
  scopes: ["user.read"],
  tenant:
    import.meta.env.VITE_AZURE_TENANT_ID ??
    "6cf18ffb-42c6-4d7d-9874-5c515ab0c6ae",
};

// ─── MyDTAS ──────────────────────────────────────────────────────────────────
export const MYDTAS_API = import.meta.env.VITE_MYDTAS_API ?? "";

// ─── Legacy alias'lar (mevcut import'lar çalışmaya devam eder) ───────────────
export const DAIKING_API = API_BASE_URL;
export const TIMEZONE = APP_TIMEZONE;
